export default [
    {
        key: "document_info",
        label: app.$i18n.t("Document information"),
        visible: true
    },
    {
        key: "origin",
        label: app.$i18n.t("Origin"),
        visible: true
    },
    {
        key: "destination",
        label: app.$i18n.t("Destination"),
        visible: true
    },
    {
        key: "transport_info",
        label: app.$i18n.t("Transport information"),
        visible: true
    },
    {
        key: "codes",
        label: app.$i18n.t("Codes"),
        visible: true
    },
    {
        key: "observations",
        label: app.$i18n.t("Observation"),
        visible: true
    },
    {
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true
    }
];